import { Box, Tooltip, Typography } from "@mui/material"
import { ListGiftModel } from "src/types"
import TemBox from "../TemBox"
import { getImagePath } from "src/utils/getImagePath"
import { theme } from "src/providers/ThemeProvider"
import { formatNumber } from "src/utils/formatNumber"

interface IGiftBoxProps {
  data: ListGiftModel
}

const GiftBox = ({ data }: IGiftBoxProps) => {
  return (
    <Box pr={1} pl={3} py={2}>
      <Box sx={{ position: "relative" }}>
        <Box
          sx={{
            [theme.breakpoints.down(600)]: {
              top: -5,
              left: -22,
            },
          }}
          zIndex={999}
          position="absolute"
          top={-12}
          left={-26}
        >
          <TemBox temQuantity={data.TemQuantity} />
        </Box>
        <Box
          position="relative"
          display="flex"
          flexDirection="column"
          height="100%"
          width={260}
          sx={{
            [theme.breakpoints.down(900)]: {
              width: 220,
              height: 200,
            },
            [theme.breakpoints.down(600)]: {
              width: 180,
              height: 160,
            },
            [theme.breakpoints.down(450)]: {
              width: 220,
              height: 200,
            },
          }}
        >
          <Box
            sx={{
              padding: "4px 12px 4px 50px",
              [theme.breakpoints.down(600)]: {
                padding: "4px 8px 4px 30px",
                "& p": {
                  fontSize: 11,
                  lineHeight: "16px",
                },
              },
            }}
            borderRadius="24px 24px 0 0"
            bgcolor="#1FA009"
            color="white"
          >
            <Tooltip title={data?.ProductName}>
              <span>
                <Typography
                  fontSize={16}
                  fontFamily="Roboto Slab, serif"
                  lineHeight={"21px"}
                  overflow="hidden"
                  textOverflow="ellipsis"
                  whiteSpace="nowrap"
                >
                  {data.ProductName}
                </Typography>
              </span>
            </Tooltip>
            <Typography
              fontSize={16}
              fontFamily="Roboto Slab, serif"
              lineHeight={"21px"}
            >
              Trị giá{" "}
              <span
                style={{
                  fontFamily: "sans-serif",
                  fontWeight: "bold",
                }}
              >
                {formatNumber(data.SalePrice || 0)}đ
              </span>
            </Typography>
          </Box>
          <Box
            textAlign="center"
            flexGrow={1}
            borderRadius=" 0 0 24px 24px"
            bgcolor="white"
            width="100%"
            sx={{
              height: 200,
              [theme.breakpoints.down(900)]: {
                height: 165,
                minHeight: 165,
              },
              textAlign: "center",
              [theme.breakpoints.down(600)]: {
                height: 140,
                minHeight: 140,
              },
            }}
          >
            <img
              width="80%"
              height="100%"
              src={getImagePath(data.ProductDefaultImage)}
              alt={data.ProductName}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default GiftBox
